module.exports = __webpack_public_path__ + "img/ico-reaction-04.1304ea07.svg";